(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function OEProductSubnav(elem) {
        Behaviors.init(OEProductSubnav, this, arguments);

        var $thisElem = this.$elem,
            nav = $thisElem.find('.ProductSubnav-nav');

        if ($('.product-section').length > 0) {
            $('.product-section').each(function (index) {
                var id = $(this).attr('id');

                nav.append('<li><a href="#' + id + '">' + id + '</a></li>');
            });
        }

        $(document).on('click', '.ProductSubnav-nav a', function(e){
            e.preventDefault();

            var id = $(this).attr('href'),
                scrollTop = $(id).offset().top - $('header').outerHeight() - $thisElem.outerHeight();

            $('html, body').animate({
                'scrollTop': scrollTop
            }, 500);
        });
    }

    Behaviors.inherit(OEProductSubnav, Behaviors.Behavior);

    OEProductSubnav.QUERY = "[data-oeproduct-subnav]";

    Behaviors.register_behavior(OEProductSubnav);

    module.OEProductSubnav = OEProductSubnav;

    return module;

}(window.jQuery, window.Behaviors));